import { useTranslate } from '~/shared/context/use-translate';
import { ActivityTimelineCard } from '~/ui/domain/chat/ActivityTimelineCard';

import type { StatusUpdateBlock } from '../../data-contract/chat';
import type { BlockRenderer } from './types';

const StatusUpdate = ({ block }: { readonly block: StatusUpdateBlock }) => {
    const translate = useTranslate();
    return (
        <ActivityTimelineCard
            autoCollapseWhenComplete={true}
            defaultCollapsed={block.finished}
            doneLabel={translate('common.done')}
            steps={[
                {
                    id: block.blockId,
                    label: block.label,
                    status: block.finished ? 'complete' : 'active',
                },
            ]}
            title="Agent activity"
        />
    );
};

export const statusUpdateBlockRenderer: BlockRenderer<StatusUpdateBlock> = {
    isAnswered: () => true,
    renderInline: (block) => <StatusUpdate block={block} />,
    type: 'status-update',
};
